export default "__VITE_ASSET__CNxcavoP__"